export default __webpack_public_path__ + "assets/media/favicon120.f94a7ae16422ed52a90d1619dfcaf8fe.png";